import {
  Component,
  OnInit,
  ChangeDetectorRef,
  AfterContentChecked,
  Renderer2,
  Inject,
} from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import {
  ConfigService,
  DatastoreService,
  CommonFunctionsService,
  NotificationStoreService,
  ApiService,
} from 'src/app/services/index';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subject, timer } from 'rxjs';
import { DOCUMENT } from '@angular/common';
import { OnlineStatusService, OnlineStatusType } from 'ngx-online-status';
import { TranslatorService } from './services/translator.service';
import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';
import { Ajax } from '@newrelic/browser-agent/features/ajax';
import { JSErrors } from '@newrelic/browser-agent/features/jserrors';
import { Metrics } from '@newrelic/browser-agent/features/metrics';
import { PageAction } from '@newrelic/browser-agent/features/page_action';
import { PageViewEvent } from '@newrelic/browser-agent/features/page_view_event';
import { PageViewTiming } from '@newrelic/browser-agent/features/page_view_timing';
import { SessionTrace } from '@newrelic/browser-agent/features/session_trace';
import { Spa } from '@newrelic/browser-agent/features/spa';
import packageJson from '../../package.json';
import moment from 'moment';
import { MsalService, MsalBroadcastService } from '@azure/msal-angular';
import { EventMessage, EventType, InteractionStatus } from '@azure/msal-browser';
import { filter, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, AfterContentChecked {
  title = 'kiosk-check-in-core';
  favIcon: HTMLLinkElement = document.querySelector(
    '#appIcon'
  ) as HTMLLinkElement;
  errors: any = [];
  loadIssue = false;
  connectionIssue = false;
  config: any;
  everySecond: Observable<any> = timer(0, 1000);
  countDown = 10;
  status: OnlineStatusType = 1; //Enum provided by ngx-online-status
  onlineStatusCheck: any = OnlineStatusType;
  startTime = false;
  showRoutlet = false;
  paramRout: string;
  private readonly _destroying$ = new Subject<void>();
  constructor(
    private configService: ConfigService,
    private titleService: Title,
    private translate: TranslateService,
    public translatorService: TranslatorService,
    public dataStore: DatastoreService,
    private commonFunctionsService: CommonFunctionsService,
    private apiService: ApiService,
    private notifStore: NotificationStoreService,
    private router: Router,
    private cdref: ChangeDetectorRef,
    private onlineStatusService: OnlineStatusService,
    private broadcastService: MsalBroadcastService,
    private authService: MsalService
  ) {
    // Populate using values in copy-paste JavaScript snippet.
    this.dataStore.version = packageJson.version;
    const options = {
      init: {
        distributed_tracing: { enabled: true },
        privacy: { cookies_enabled: true },
        ajax: { deny_list: ['bam.eu01.nr-data.net'] },
        jserrors: { enabled: true },
        metrics: { enabled: true },
        page_action: { enabled: true },
        page_view_timing: { enabled: true },
        session_trace: { enabled: true },
      }, // NREUM.init
      info: {
        beacon: 'bam.eu01.nr-data.net',
        errorBeacon: 'bam.eu01.nr-data.net',
        licenseKey: 'NRJS-875de46bf3368f7e31c',
        applicationID: '538537379',
        sa: 1,
      }, // NREUM.info
      loader_config: {
        accountID: '3263467',
        trustKey: '3263467',
        agentID: '538537379',
        licenseKey: 'NRJS-875de46bf3368f7e31c',
        applicationID: '538537379',
      }, // NREUM.loader_config
      features: [
        Metrics,
        JSErrors,
        PageViewEvent,
        PageViewTiming,
        Ajax,
        PageAction,
        SessionTrace,
        Spa,
      ],
    };

    // The agent loader code executes immediately on instantiation.
    this.dataStore.newrelic = new BrowserAgent(options);

    translate.setDefaultLang('en');
    (window as any).GOVUKFrontend.initAll();
  }

  ngAfterContentChecked(): void {
    this.cdref.detectChanges();
  }

  async ngOnInit(): Promise<void> {
    console.info(`BOOKINGLAB CHECKIN APP VERSION ${packageJson.version}`);

    this.getConfig();

    this.everySecond.subscribe((seconds: any) => {
      if (this.dataStore.timer) {
        this.startTime = true;
      } else this.startTime = false;
    });
    this.onlineStatusService.status.subscribe((status: OnlineStatusType) => {
      // Retrieve Online status Type
      this.status = status;
    });

    this.commonFunctionsService.getRequestError().subscribe((err: any) => {
      if (err) {
        this.loadIssue = true;
        if (err.status === 0) {
          this.connectionIssue = true;
        }
        this.errors.push(err.message);
      } else {
        this.errors = [];
        this.loadIssue = false;
      }
    });

    const wa = setInterval(() => {
      this.commonFunctionsService.fontChecker();
    }, 500);

    const refresh = setInterval(() => {
      this.dataStore.refreshTimer++;
    }, 1000);

    let authToken = localStorage.getItem('auth_token');
    let memberObject = localStorage.getItem('loginObject');

    console.log(authToken);
    if (authToken != 'undefined' && memberObject) {
      this.alreadyLoggedIn(JSON.parse(memberObject));
      this.dataStore.authToken = authToken;
    }
  }

  redirect() {
    this.commonFunctionsService.newBooking();
    this.router.navigate(['/access']);
  }

  async getConfig() {
    window.location.href;
    // http://localhost:4201/bookinglab-demo/37200/

    const splitHref = window.location.href.split('/');
    console.log(splitHref);
    if (splitHref[4].indexOf('#') !== -1) {
      splitHref[4] = splitHref[4].split('#')[0];
    }
    if (splitHref[3] && splitHref[4]) {
      const params = { site: splitHref[3], comp: splitHref[4] };
      const config = await this.commonFunctionsService.setCompanyName(params);
      this.showRoutlet = true;
      this.paramRout = `${params.site}/${params.comp}`;
      if (config) {
        this.config = config;
        let authToken = localStorage.getItem('auth_token');
        let memberObject = localStorage.getItem('loginObject');
        console.log(authToken != 'undefined' && memberObject);
        // if (authToken === 'undefined' || !memberObject) {
        //   this.router.navigate([`/${params.site}/${params.comp}/login`]);
        // } else {
        //   this.router.navigate([
        //     `/${params.site}/${params.comp}/arrival/confirmed`,
        //   ]);
        // }
      } else {
        this.router.navigate([`/${params.site}/${params.comp}/404`]);
      }
    }
    this.notifStore.onsessionUpdate(true);
    return this.config;
  }

  isLoggedIn() {
    if (this.dataStore.config) {
      let requireLogin = JSON.parse(this.dataStore.config).requireLogin;
      return (
        this.dataStore.loggedIn &&
        !(this.router.url === '/account' && !requireLogin)
      );
    } else {
      return false;
    }
  }

  resetApp() {
    location.reload();
  }

  goToCustomizable(page: string) {
    this.router
      .navigateByUrl('/', { skipLocationChange: true }) // skip means we don't actually go to /
      .then(() => this.router.navigate([`/${this.paramRout}/arrival/${page}`])); // doing just rout to details would not work as we are already there
  }

  goToPage(page: string) {
    console.log(page);
    this.router
      .navigateByUrl('/', { skipLocationChange: true }) // skip means we don't actually go to /
      .then(() => this.router.navigate([`/${this.paramRout}/${page}`])); // doing just rout to details would not work as we are already there
  }

  signOut() {
    this.commonFunctionsService.logout();
  }

  checkRout(txt: string) {
    return this.router.url.includes(txt);
  }

  alreadyLoggedIn(memberObject: any) {
    this.dataStore.loginObject = memberObject;
    if (memberObject['_embedded']) {
      if (memberObject['_embedded'].members.length >= 1) {
        this.dataStore.loginObject.member =
          memberObject['_embedded'].members[0];
      }
      if (memberObject['_embedded'].administrators.length >= 1) {
        this.dataStore.loginObject.member =
          memberObject['_embedded'].administrators[0];
      }
    }

    // set login on localstorage encase refresh
    localStorage.setItem('auth_token', this.dataStore.loginObject.auth_token);
    localStorage.setItem(
      'loginObject',
      JSON.stringify(this.dataStore.loginObject)
    );
    this.dataStore.loggedIn = true;
    this.notifStore.onsessionUpdate(true);
  }
}
